import { getUserInfoQuery } from 'dataLayer/game'
import { createContext, useContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'

const NotificationContext = createContext(null)

export const NotificationProvider = ({ children }) => {
	const [message, setMessage] = useState('')
	const [count, setCount] = useState(0)
	const [visible, setVisible] = useState(false)

	const [isOn, setIsOn] = useState(() => {
		return localStorage.getItem('background_music') === '1';
	});

	const { data: userInfo } = useQuery(getUserInfoQuery());

	useEffect(() => {
		const local = localStorage.getItem('background_music');

		if (local !== null) return;

		if (userInfo?.background_music !== undefined) {
			const value = userInfo.background_music === 1;

			setIsOn(value);
			localStorage.setItem('background_music', value ? '1' : '0');
		}
	}, [userInfo]);

	const updateMusic = (value) => {
		setIsOn(value);
		localStorage.setItem('background_music', value ? '1' : '0');
	};

	const pushNotification = (msg, number = 1) => {
		setMessage(msg)
		setCount(prev => prev + number)
		setVisible(true)
	}

	const clearNotification = () => {
		setMessage('')
		setCount(0)
		setVisible(false)
	}

	return (
		<NotificationContext.Provider
			value={{
				message,
				count,
				visible,
				pushNotification,
				clearNotification,
				isOn,
				setIsOn: updateMusic
			}}
		>
			{children}
		</NotificationContext.Provider>
	)
}

export const useNotification = () => {
	const ctx = useContext(NotificationContext)
	if (!ctx) {
		throw new Error('lỗi')
	}
	return ctx
}
